import React from 'react'
import { ConnectedRouter } from 'react-router-redux'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import configureStore, { history } from './store'
import App from './containers/App'
import { configureGraphqlClient } from 'util/graphqlClient'
import debug from 'debug'

// Set debug from (compile-time) ENV variable,
//
//  - if not already set explicitly earlier, and
//  - if env variable present at compile-time
//
if (!debug.names || debug.names.length === 0) {
  if (process.env.DEBUG && process.env.DEBUG.length > 0) {
    debug.enable(`${process.env.DEBUG}`)
  }
}

window.linkguaDebug = debug

export const {store, persistor} = configureStore()
configureGraphqlClient(store)

const MainApp = () =>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App}/>
        </Switch>
      </ConnectedRouter>
    </PersistGate>
  </Provider>

export default MainApp



// WEBPACK FOOTER //
// ./MainApp.js